import React from 'react';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CallTemplate } from 'bundles/connect/types';
import { Button, Col, ListGroup, Row } from 'react-bootstrap-5';
import { displayToast } from '../../helpers/display_toast';
import { deleteCallTemplate } from '../../helpers/prospect_api';

type CallTemplateRowProps = {
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setTemplate: React.Dispatch<React.SetStateAction<CallTemplate>>;
  setTemplates: React.Dispatch<React.SetStateAction<CallTemplate[]>>;
  template: CallTemplate;
}
export default function CallTemplateRow({ setShow, setTemplate, setTemplates, template }: CallTemplateRowProps) {
  const handleDelete = async (id: number) => {
    confirm('Are you sure you want to delete this template?') && await deleteCallTemplate(id)
      .then(() => {
        displayToast('Call Template successfully deleted', 'success');
        setTemplates(prevTemplates => prevTemplates.filter(template => template.id !== id));
      });
  };

  const handleClick = () => {
    setTemplate(template);
    setShow(true);
  };

  return (
    <ListGroup.Item>
      <Row className="align-items-center">
        <Col>
          <Button className="p-0" variant="link" onClick={handleClick}>
            <strong>{template.title}</strong>
          </Button>
        </Col>
        <Col xs="auto">
          <Button variant="shaded-danger" onClick={() => handleDelete(template.id)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </Col>
      </Row>
    </ListGroup.Item>
  );
}
